<style scoped></style>
<template>
  <nav>
    <div
      :class="{
        'max-w-6xl mx-auto py-2 sm:px-6 lg:px-8 flex': true,
        'justify-between': logo,
        'justify-end': !logo,
      }"
    >
      <img v-if="logo" :src="logo" class="h-10" alt="" />
      <div
        v-if="saveState == 'saving'"
        class="inline-flex items-center text-gray-800 text-sm"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          class="mr-2 h-4 w-4"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
        {{ $t('form.saving') }}
      </div>
      <div
        v-if="saveState == 'idle'"
        class="inline-flex items-center text-gray-800 text-sm"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          class="mr-2 h-4 w-4"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"
          />
        </svg>
        {{ $t('form.saved') }}
      </div>
      <div
        v-if="saveState == 'error'"
        class="inline-flex items-center text-red-600 text-sm"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          class="mr-2 h-4 w-4"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        {{ $t('form.connection_error') }}
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: 'NavigationComponent',
  props: {
    logo: String,
    saveState: String,
  },
};
</script>
